








































































import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import { Contact } from '@contacts/interfaces/contact';
import { CustomContactFieldInterface } from '@contacts/interfaces/custom-contact-field';
import TextInput from '@shared/components/forms/inputs/input/input.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';

@Component({
  name: 'bpc-custom-contact-field',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-input': TextInput,
    'bpc-textarea': Textarea,
    'bpc-select': Select,
    'bpc-multi-select': MultiSelect,
    'bpc-switch': Switch,
    'bpc-datepicker': Datepicker,
  },
})
export default class CustomContactFieldsInput extends mixins(AbstractField) {
  @Prop(Object) declare readonly formModel: Contact;
  @Prop(Object) readonly field: CustomContactFieldInterface;
  @Prop([String, Array, Boolean, Number]) value: string | boolean | [] | number;
  @Prop({ type: Boolean, default: false }) readonly switchToSimpleSelect: boolean;

  public labelInputAttributes = {
    for: 'global__',
    cols: 12,
  };

  public switchOptions = [
    { text: 'global.yes', value: 'true' },
    { text: 'global.no', value: 'false' },
  ];

  // format options for selects.
  formatOptions(options) {
    const optionsSplitted = options.split(';');
    const optionsArray = [];
    optionsSplitted.forEach(option => {
      const trimmedOption = option.trim();
      if (trimmedOption !== '') {
        optionsArray.push({ text: trimmedOption, value: trimmedOption });
      }
    });

    return optionsArray;
  }

  onChange(field, value) {
    this.$emit('input', { field: field, value: value });
  }
}
